import { render, staticRenderFns } from "./ProductApproveListTable.vue?vue&type=template&id=539bdaf9"
import script from "./ProductApproveListTable.vue?vue&type=script&lang=js"
export * from "./ProductApproveListTable.vue?vue&type=script&lang=js"
import style0 from "./ProductApproveListTable.vue?vue&type=style&index=0&id=539bdaf9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports